module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BoldItalic.212a1d25.ttf";